var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideoOctagon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 4.8 4.8 0 24 0C43.2 0 48 4.8 48 24C48 43.2 43.2 48 24 48C4.8 48 0 43.2 0 24Z",
    fill: "#8282FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6202 18.8701V29.13C37.6202 30.81 36.7202 32.3701 35.2652 33.2251L26.3552 38.3701C24.9002 39.2101 23.1002 39.2101 21.6302 38.3701L12.7202 33.2251C11.2652 32.3851 10.3652 30.825 10.3652 29.13V18.8701C10.3652 17.1901 11.2652 15.63 12.7202 14.775L21.6302 9.63C23.0852 8.79 24.8852 8.79 26.3552 9.63L35.2652 14.775C36.7202 15.63 37.6202 17.1751 37.6202 18.8701Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.625 24.0003V22.2003C20.625 19.8903 22.26 18.9454 24.255 20.1004L25.815 21.0003L27.375 21.9003C29.37 23.0553 29.37 24.9454 27.375 26.1004L25.815 27.0003L24.255 27.9003C22.26 29.0553 20.625 28.1104 20.625 25.8004V24.0003Z",
    fill: "#111827"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoOctagon);
export default __webpack_public_path__ + "static/media/videoOctagon.9447c1aa0f47c8fbd7666570cac23b2b.svg";
export { ForwardRef as ReactComponent };